import type { TefComs } from '@mfec/types/tefComs';
import { LitElement } from 'lit';

type Constructor<T = object> = new (...args: any[]) => T; // eslint-disable-line @typescript-eslint/no-explicit-any

export declare class TriggerEventMixinI {
  triggerEvent(details: TefComs.CustomEventDetails): void;
}

export const TriggerEventMixin = <T extends Constructor<LitElement>>(superClass: T, componentTagName: string) => {
  class TriggerEventMixinClass extends superClass {
    // Triggers an event on the component that can be caught on the <element> from outside.
    // See test-app.ts
    triggerEvent(details: TefComs.CustomEventDetails) {
      // Used outside shadowRoot (see https://developer.mozilla.org/en-US/docs/Web/API/Event/Event#composed)
      const event = new CustomEvent<TefComs.CustomEventDetails>(componentTagName, {
        bubbles: true,
        composed: true,
        detail: details,
      });
      this.dispatchEvent(event);
    }
  }
  return TriggerEventMixinClass as Constructor<TriggerEventMixinI> & T;
};
